import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { endWith, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import * as moment from 'moment';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-make745-card-I',
  templateUrl: './make745-card-I.component.html'
})

export class Make745CardIComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;

  public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listSafra?: DropDownListDTO[];
  public listSafraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listLinhaEnsaque?: DropDownListDTO[] = [];
  public listTurnoEnsaque?: DropDownListDTO[] = [];
  public listLoteDs: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLoteDsOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  dropdownLoteds = false;
  public listCentro?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listCentroOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  @Output() mkCalc = new EventEmitter();

  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
    super('Dados Ensaque em CS', false);

    this.formulario = this.formBuilder.group({
      centro_ensaque: ['', []],
      data_ensaque: [null, [Validators.pattern(this.regexDate)]],
      numero_campo: ['', []],
      safra: ['', []],
      hibrido_rnc: ['', []],
      geracao: ['', []],
      lote_origem: ['', []],
      peneira: ['', []],
      lote_saida: ['', [Validators.pattern('\^[A-Z][0-9][A-Z](?:[0-9]{2}[CMLR]|[0-9]{2}R[ML]?|R3[ML]?|SC)[0-9]{2}[A-Z]{2}')]],
      peso_sessenta_mil_sementes_impressao_kg: ['', [Validators.max(30)]],
      peso_total_lote_kg: ['', []],
      estimativa_pa: ['', []],
      linha_ensaque: ['', []],
      turno_ensaque: ['', []],
      responsavel_pelo_ensaque: ['', []],
      status_lote: ['', []],
    });
  }

  async ngOnInit(): Promise<void> {
    await Promise.all([this.getLists()]);
  }

  async getLists(): Promise<void> {
    await Promise.all([this.getListCentro(), this.getPeneiraBasicDropdownOptions(), this.getListSafra(), this.getLinhaEnsaque(), this.getTurnoEnsaque()]);
  }


  async getTurnoEnsaque(): Promise<void> {
    await this.formularioService
      .getListDropDownList('ensaque_cs_0745', 'turno_ensaque')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listTurnoEnsaque = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          )
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorSafra
        );
      });
  }

  async getLinhaEnsaque(): Promise<void> {
    await this.formularioService
      .getListDropDownList('ensaque_cs_0745', 'linha_ensaque')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listLinhaEnsaque = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          )
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorSafra
        );
      });
  }

  async getListSafra(): Promise<void> {
    await this.formularioService
      .getListDropDownList('ensaque_cs_0745', 'safra')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listSafra = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listSafraOriginal = this.listSafra;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorSafra
        );
      });
  }

  async getListCentro(): Promise<void> {
    await this.formularioService.getListDropDownList('qua042', 'centro_ensaque').pipe(take(1)).toPromise().then((response: any) => {
      if (!!response?.data) {
        this.listCentro = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listCentroOriginal = this.listCentro;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    });
  }
  changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  getPeneiraBasicDropdownOptions(): void {
    this.formularioService
      .getListDropDownList('ensaque_cs_0745', 'peneira', 'CDR')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listPeneira = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraOriginal = this.listPeneira
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneira
        );
      });
  }

  validateDate(event): void {
    switch (event.srcElement.id) {
      case "txtDataEnsaque":
        if (moment(this.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY") > moment())
          this.formulario?.controls['data_ensaque'].setErrors({ 'dateHighThanActual': true });
        else if (moment(this.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY") <= moment())
          this.formulario?.controls['data_ensaque'].setErrors(null);
    }
  }

  setStatusLote(): void {
    switch (this.formulario?.controls['lote_saida'].value.slice(-1)) {
      case 'A':
        this.formulario?.controls['status_lote'].setValue("Aprovado");
        break;
      case 'D':
        this.formulario?.controls['status_lote'].setValue("Reprovado Defeito");
        break;
      case 'P':
        this.formulario?.controls['status_lote'].setValue("Reprovado Plantabilidade");
        break;
      case 'R':
        this.formulario?.controls['status_lote'].setValue("Reprovado Plantabilidade e Defeito");
        break;
      case 'X':
        this.formulario?.controls['status_lote'].setValue("Reprovado Retenção");
        break;
    }
  }

  async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }

  updateFields(): void {
    this.getMaterialGeracao();
    this.getPc003Data();
  }

  getMaterialGeracao(): void {
    this.formularioService.getPc003Data(null, this.formulario?.get('safra').value, this.formulario?.get('numero_campo').value).pipe(take(1)).toPromise().then((objPC003: any) => {
      this.formulario?.get('hibrido_rnc').setValue(objPC003?.data?.hibrido_rnc);
      this.formulario?.get('geracao').setValue(objPC003?.data?.geracao);
    });
  }

  getPc003Data() {
    const safra = this.formulario.controls.safra.value;
    const numeroCampo = this.formulario.controls.numero_campo.value;

    if (
      safra != '' &&
      safra != null &&
      numeroCampo != '' &&
      numeroCampo != null
    ) {
      this.getListLoteDs(safra, numeroCampo);
    }
  }

  async getListLoteDs(safra: string, numeroCampo: string): Promise<void> {
    await this.formularioService
      .getListDropDownLoteDS(safra, numeroCampo)
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data && response.data.length > 0) {
          this.listLoteDs = this.generalService.orderByDropDownList(
            response.data.map((item, i) => {
              return { name: item.lote_ds };
            }) as DropDownListDTO[]
          );
          this.listLoteDsOriginal = this.listLoteDs;
          this.dropdownLoteds = true;
          this.formulario.get('lote_origem').enable();
          this.formulario.get('lote_origem').updateValueAndValidity();
        } else {
          this.listLoteDs = [];
          this.dropdownLoteds = false;
          this.formulario.get('lote_origem').enable();
          this.formulario.get('lote_origem').updateValueAndValidity();
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneira
        );
      });
  }

}


